<template>
  <div class="home-warg">
    <div class="home-ads">
      <img src="../../assets/img/logo/home_ads.png">
      </div>
    </div>
</template>
<script>
export default {
  name: 'homeAds'
}
</script>

<style lang="scss" scoped>
.home-warg{
  box-sizing: border-box;
  margin: 0 auto;
  text-align: -webkit-center;
}
.home-ads{
  width: 1226px;
  height: 105px;
  justify-content: space-between;
  display: flex;
  img{
    width: 100%;
    height: 92px;
  }
/*  img{
    width: 266px;
    height: 72px;
    margin-top: 20px;
    color: #32A08C;
  }*/
}
</style>
